<template>
    <div v-if="model">
        <rkm-form ref="RkmForm">
            <rkm-tabs>
                <rkm-tab title="Pré-atendimento">
                    <rkm-row v-if="servicos.length > 0">
                        <rkm-col cols="12">
                            <rkm-alert color="info">
                                <strong>Serviços:</strong> {{servicos}}
                            </rkm-alert>
                        </rkm-col>
                    </rkm-row>

                    <BoxMotivoAtendimento :data="{form, model}" />

                    <BoxAntropometria
                        :data="{form: form.preAtendimento, model: model.preAtendimento}"
                        @alturaChange="handleAlturaChange"
                        @circunferenciaAbdominalChange="handleCircunferenciaAbdominalChange"
                        @perimetroCefalicoChange="handlePerimetroCefalicoChange"
                        @perimetroPanturrilhaChange="handlePerimetroPanturrilhaChange"
                        @pesoChange="handlePesoChange"
                    />

                    <BoxSinalVital
                        :data="{model: model.preAtendimento}"
                        @pressaoArterialChange="handlePressaoArterialChange"
                        @temperaturaChange="handleTemperaturaChange"
                    />

                    <BoxGlicemiaCapilar
                        :data="{form: form.preAtendimento, model: model.preAtendimento}"
                        @glicemiaCapilarChange="handleGlicemiaCapilarChange"
                    />

                    <rkm-row class="mt-2">
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                class="mb-0"
                                label="Vacinação em dia"
                                v-model="model.preAtendimento.vacinacaoEmDia"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                                <rkm-form-radio :value="null">Não informado</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row
                        v-if="isIdadeGestacional()"
                        class="mt-2"
                    >
                        <rkm-col cols="2">
                            <rkm-form-date-picker
                                :max-date="additionals.dataAtual"
                                :min-date="form.paciente.dataNascimento"
                                label="DUM"
                                v-model="model.preAtendimento.dum"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-date-picker
                                :value="form.preAtendimento.ultimaDum ? others.moment(form.preAtendimento.ultimaDum, 'DD/MM/YYYY').toDate() : null"
                                disabled
                                label="Última DUM"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-date-picker
                                :value="form.preAtendimento.dataUltimoAtendimentoPreNatal ? others.moment(form.preAtendimento.dataUltimoAtendimentoPreNatal, 'DD/MM/YYYY').toDate() : null"
                                disabled
                                label="Data do último atendimento de pré-natal"
                            />
                        </rkm-col>
                    </rkm-row>

                    <BoxTesteRapido
                        :data="{form, model}"
                        @testeRapidoChange="handleTesteRapidoChange"
                    />

                    <BoxAdministracaoMedicamento
                        :data="{form, model}"
                        @administracaoMedicamentoChange="handleAdministracaoMedicamentoChange"
                    />

                    <BoxOutroProcedimento
                        :data="{form, model}"
                        @outroProcedimentoChange="handleOutroProcedimentoChange"
                    />

                    <BoxColetaMaterial
                        :data="{form, model}"
                        @coletaMaterialChange="handleColetaMaterialChange"
                    />

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-checkbox
                                class="mt-2"
                                v-model="model.preAtendimento.orientacaoIndividualEmSaude"
                            >
                                Orientação individual em saúde
                            </rkm-form-checkbox>
                        </rkm-col>
                    </rkm-row>

                    <BoxProcedimento :data="{form: form, model: model.preAtendimento}" />

                    <BoxMedicamento :data="{form: form, model: model.preAtendimento}" />

                    <BoxClassificacaoRisco
                        v-if="additionals.podeAlterarClassificacaoRisco"
                        :data="{form: form.preAtendimento, model: model.preAtendimento}"
                    />

                    <rkm-row class="mt-3">
                        <rkm-col>
                            <rkm-form-radio-group
                                :options="form.preAtendimento.demandaTipos"
                                disabled
                                label="Tipo de demanda"
                                v-model="model.preAtendimento.demandaTipo"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!model.preAtendimento.demandaTipo">
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                :options="atendimentoTipos"
                                :validations="validations.atendimentoTipo"
                                label="Tipo de atendimento"
                                text-field="nome"
                                v-model="model.preAtendimento.atendimentoTipoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-select
                                :options="form.preAtendimento.equipes"
                                label="Equipe"
                                show-default-option
                                text-field="descricao"
                                v-model="model.preAtendimento.equipeId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="form.preAtendimento.turnos"
                                :validations="validations.turno"
                                label="Turno"
                                text-field="nome"
                                v-model="model.preAtendimento.turnoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="form.preAtendimento.locaisAtendimento"
                                :validations="validations.atencaoBasicaLocalAtendimento"
                                label="Local de atendimento"
                                text-field="descricao"
                                v-model="model.preAtendimento.atencaoBasicaLocalAtendimentoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <BoxDesfecho
                        :data="{additionals, form: form.preAtendimento, model: model.preAtendimento}"
                        :fila-id="filaId"
                    />
                </rkm-tab>

                <rkm-tab title="Histórico" v-if="hasPermissao('show-ambulatorio-historico-atendimento')">
                    <BoxHistorico :data="{form}" />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>

        <rkm-fab-area>
            <rkm-fab>
                <rkm-fab-item
                    @click="$refs.ModalColetaExameLaboratorial.open()"
                    icon="search"
                    label="Coleta de exame laboratorial"
                />

                <rkm-fab-item
                    @click="$refs.ModalMedicao.open()"
                    icon="search"
                    label="Medições"
                />

                <rkm-fab-item
                    @click="$refs.ModalRegistroVacinacao.open()"
                    icon="search"
                    label="Registro de vacinação"
                />
            </rkm-fab>
        </rkm-fab-area>

        <rkm-area
            title="Profissional realizando o atendimento"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <strong>Profissional: </strong> {{ autenticacao.usuario.cidadao.nome }}
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <strong>CBO: </strong> {{ autenticacao.lotacao.ocupacao.codigo }} - {{ autenticacao.lotacao.ocupacao.nome }}
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="autenticacao.usuario.registroTipo && autenticacao.usuario.registroNumero">
                <rkm-col>
                    <strong>{{ autenticacao.usuario.registroTipoId == enums.tipoRegistro.OUTRO
                        ? autenticacao.usuario.registroTipoOutro
                        : autenticacao.usuario.registroTipo.sigla }}: </strong> {{ autenticacao.usuario.registroNumero }}
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <strong>Data do atendimento: </strong> {{ additionals.dataAtual }} {{ additionals.horaInicioAtendimento }}
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <ModalColetaExameLaboratorial
            :data="{
                form: form.coletaExameLaboratorial,
                model: model.coletaExameLaboratorial,
            }"
            ref="ModalColetaExameLaboratorial"
        />

        <ModalMedicao
            :data="{
                additionals: {
                    ...additionals,
                    paciente: form.paciente,
                },
                form: form.medicoes,
                model: model.medicoes,
            }"
            ref="ModalMedicao"
            readonly
        />

        <ModalRegistroVacinacao
            :data="{
                additionals: additionals.registroVacinacao,
                form: form.registroVacinacao,
                model: model.registroVacinacao,
                pacienteId: form.paciente.id
            }"
            ref="ModalRegistroVacinacao"
        />

        <ModalDeclaracaoComparecimento
            @canceled="canceledModalDeclaracaoComparecimento"
            @saved="savedModalDeclaracaoComparecimento"
            ref="ModalDeclaracaoComparecimento"
        />

        <ModalImpressao
            @closed="closedModalImpressao"
            ref="ModalImpressao"
        />
    </div>
</template>

<script>
// Components.
import BoxAdministracaoMedicamento from './components/administracao-medicamento/Form'
import BoxAntropometria from '@/components/ambulatorio/components/antropometria/Index'
import BoxClassificacaoRisco from '@/components/ambulatorio/components/classificacao-risco/Index'
import BoxColetaMaterial from './components/coleta-material/Form'
import BoxDesfecho from './components/desfecho/Form'
import BoxGlicemiaCapilar from '@/components/ambulatorio/components/glicemia-capilar/Index'
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index'
import BoxMedicamento from './components/medicamento/Index'
import BoxMotivoAtendimento from './components/motivo-atendimento/Form'
import BoxOutroProcedimento from './components/outro-procedimento/Form'
import BoxProcedimento from './components/procedimento/Index'
import BoxSinalVital from '@/components/ambulatorio/components/sinal-vital/Index'
import BoxTesteRapido from './components/teste-rapido/Form'
import ModalColetaExameLaboratorial from './components/coleta-exame-laboratorial/Modal'
import ModalDeclaracaoComparecimento from '@/components/ambulatorio/components/declaracao-comparecimento/Modal'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'
import ModalMedicao from '@/components/ambulatorio/atendimento/components/medicao/Modal'
import ModalRegistroVacinacao from './components/registro-vacinacao/Modal'

// Enums.
import demandaTipo from '@/enums/ambulatorio/demandaTipo'
import procedimento from '@/enums/sigtap/procedimento'
import sexo from '@/enums/cadastro/cidadao/sexo'
import statusAgendamentoExameLaboratorial from '@/enums/exame-laboratorial/statusAgendamento'
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

// Mixins.
import {error, file, permissao, repository, stringCase, unmask} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        BoxAdministracaoMedicamento,
        BoxAntropometria,
        BoxClassificacaoRisco,
        BoxColetaMaterial,
        BoxDesfecho,
        BoxGlicemiaCapilar,
        BoxHistorico,
        BoxMedicamento,
        BoxMotivoAtendimento,
        BoxOutroProcedimento,
        BoxProcedimento,
        BoxSinalVital,
        BoxTesteRapido,
        ModalColetaExameLaboratorial,
        ModalDeclaracaoComparecimento,
        ModalImpressao,
        ModalMedicao,
        ModalRegistroVacinacao,
    },
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            centroCusto: 'getCentroCusto',
            lotacao: 'getLotacao',
        }),
        atendimentoTipos() {
            if (!this.model.preAtendimento.demandaTipo) {
                return []
            }

            if (this.model.preAtendimento.demandaTipo === this.enums.demandaTipo.ESPONTANEA) {
                return this.form.preAtendimento.atendimentoTipos.filter(t => t.isDemandaEspontanea)
            }

            return this.form.preAtendimento.atendimentoTipos.filter(t => !t.isDemandaEspontanea)
        },
        validations() {
            return {
                atendimentoTipo: {required: true},
                turno: {required: !!this.model.preAtendimento.equipeId},
                atencaoBasicaLocalAtendimento: {required: !!this.model.preAtendimento.equipeId},
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            impressaoImunizacao: this.getConectaSusRepository('impressao.imunizacao'),
            atendimentoEnfermagem: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {
            demandaTipo,
            procedimento,
            sexo,
            statusAgendamentoExameLaboratorial,
            tipoRegistro,
        },
        form: null,
        model: null,
        others: {moment},
        servicos: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        hasPermissao(hash) {
            return this.verificarPermissao(hash);
        },
        load() {
            this.create()
        },
        create() {
            this.setLoading()

            this.repositories.atendimentoEnfermagem.create({funcionalidade: 'pre-atendimento', fila_id: this.filaId})
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$emit('loaded', {form: this.form})

                    if (this.additionals.hasPreAtendimento === true) {
                        this.$emit('redirect')
                    }

                    this.servicos = this.form.preAtendimento.desfecho.servicos
                        .filter(servico => this.model.preAtendimento.desfecho.servicos.includes(servico.id))
                        .map(servico => servico.nome)
                        .join(', ')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.setLoading()

            let request = {
                funcionalidade: 'pre-atendimento',
                filaId: this.filaId,
                ciapId: this.model.preAtendimento.ciap ? this.model.preAtendimento.ciap.id : null,
                motivoAtendimento: this.model.preAtendimento.motivoAtendimento,
                orientacaoIndividualEmSaude: this.model.preAtendimento.orientacaoIndividualEmSaude,
                antropometria: {
                    altura: this.model.preAtendimento.antropometria.altura,
                    circunferenciaAbdominal: this.model.preAtendimento.antropometria.circunferenciaAbdominal,
                    imc: {
                        classificacao: this.model.preAtendimento.antropometria.imc.classificacao,
                        grauObesidade: this.model.preAtendimento.antropometria.imc.grauObesidade,
                        imc: this.model.preAtendimento.antropometria.imc.imc,
                    },
                    perimetroCefalico: this.model.preAtendimento.antropometria.perimetroCefalico,
                    perimetroPanturrilha: this.model.preAtendimento.antropometria.perimetroPanturrilha,
                    peso: this.model.preAtendimento.antropometria.peso,
                },
                sinalVital: {
                    frequenciaCardiaca: this.model.preAtendimento.sinalVital.frequenciaCardiaca,
                    frequenciaRespiratoria: this.model.preAtendimento.sinalVital.frequenciaRespiratoria,
                    pressaoArterial: this.model.preAtendimento.sinalVital.pressaoArterial,
                    saturacaoO2: this.model.preAtendimento.sinalVital.saturacaoO2,
                    temperatura: this.model.preAtendimento.sinalVital.temperatura,
                },
                glicemiaCapilar: {
                    valor: this.model.preAtendimento.glicemiaCapilar.valor,
                    momentoColetaId: this.model.preAtendimento.glicemiaCapilar.momentoColetaId,
                },
                procedimentos: this.model.preAtendimento.procedimentos.map(procedimento => {
                    return {
                        procedimentoId: procedimento.id,
                        automatico: procedimento.automatico,
                        quantidade: procedimento.quantidade,
                        localCurativo: procedimento.localCurativo,
                        materiais: procedimento.materiais ? procedimento.materiais.map(m => ({
                            materialId: m.id,
                            materialQuantidade: m.quantidade,
                            materialEscolheuEntradaItemManualmente: m.materialEscolheuEntradaItemManualmente,
                            materialEntradaItens: m.materialEntradaItens
                                ? m.materialEntradaItens.filter(i => i.quantidadeSaida > 0)
                                : [],
                        }))
                        : [],
                    }
                }),
                medicamentos: this.model.preAtendimento.medicamentos.map(medicamento => {
                    return {
                        id: medicamento.id,
                        quantidade: medicamento.quantidade,
                        escolheuEntradaItemManualmente: medicamento.escolheuEntradaItemManualmente,
                        entradaItens: medicamento.entradaItens.filter(i => i.quantidadeSaida > 0),
                    }
                }),
                desfecho: {
                    finalizado: this.model.preAtendimento.desfecho.finalizado === 'encaminhar'
                        ? false
                        : this.model.preAtendimento.desfecho.finalizado,
                    servicos: this.model.preAtendimento.desfecho.servicos,
                    prioridadeId: this.model.preAtendimento.desfecho.prioridadeId,
                    centroCustoEncaminhamentoId: this.model.preAtendimento.desfecho.centroCustoEncaminhamentoId,
                    posConsulta: this.model.preAtendimento.desfecho.posConsulta,
                },
                paciente: {
                    telefonePrincipal: {
                        id: this.form.paciente.telefoneId,
                        numero: this.form.paciente.telefoneNumero ? this.unMaskPhone(this.form.paciente.telefoneNumero) : null,
                        autorizaSms: this.form.paciente.telefoneAutorizaSms,
                    },
                },
                vacinacaoEmDia: this.model.vacinacaoEmDia,
                dum: this.model.preAtendimento.dum ? this.others.moment(this.model.preAtendimento.dum).format('DD/MM/YYYY') : null,
                testesRapidos: this.model.preAtendimento.testesRapidos,
                administracoesMedicamentos: this.model.preAtendimento.administracoesMedicamentos,
                outrosProcedimentos: this.model.preAtendimento.outrosProcedimentos,
                coletasMateriais: this.model.preAtendimento.coletasMateriais,
                atendimentoTipoId: this.model.preAtendimento.atendimentoTipoId,
                equipeId: this.model.preAtendimento.equipeId,
                turnoId: this.model.preAtendimento.turnoId,
                atencaoBasicaLocalAtendimentoId: this.model.preAtendimento.atencaoBasicaLocalAtendimentoId,
                classificacaoRiscoId: this.model.preAtendimento.classificacaoRiscoId,
                coletaExameLaboratorial: {
                    agendamentos: this.model.coletaExameLaboratorial.agendamentos
                        .filter(a => a.exames.some(e => e.statusId == this.enums.statusAgendamentoExameLaboratorial.REALIZADO))
                        .map(agendamento => ({
                            agendamentoId: agendamento.agendamentoId,
                            coletaInfraestruturaId: agendamento.coletaInfraestruturaId,
                            exames: agendamento.exames
                                .filter(e => e.statusId == this.enums.statusAgendamentoExameLaboratorial.REALIZADO)
                                .map(exame => ({
                                    exameGrupoId: exame.exameGrupoId,
                                    pertenceGrupo: exame.pertenceGrupo,
                                    statusId: exame.statusId,
                                    usuarioId: exame.usuarioId,
                                    ocupacaoId: exame.ocupacaoId,
                                }))
                        }))
                },
                registroVacinacao: {
                    aplicacoes: this.model.registroVacinacao.registros
                        .filter(registro => registro.registroTipo === 'aplicacao')
                        .map(aplicacao => {
                            return {
                                id: aplicacao.id,
                                salaVacinacaoId: aplicacao.salaVacinacaoId,
                                aplicadorId: aplicacao.aplicadorId,
                                ocupacaoId: aplicacao.ocupacaoId,
                                equipeId: aplicacao.equipeId,
                                turnoId: aplicacao.turnoId,
                                localAtendimentoId: aplicacao.localAtendimentoId,
                                dataRegistro: aplicacao.dataRegistro,
                                vacinaId: aplicacao.vacinaId,
                                lote: aplicacao.lote.lote,
                                entradaId: aplicacao.lote.id,
                                dataValidadeLote: aplicacao.lote.dataValidadeLote,
                                produtorId: aplicacao.produtorId,
                                grupoAtendimentoId: aplicacao.grupoAtendimentoId,
                                doseId: aplicacao.doseId,
                                estrategiaId: aplicacao.estrategiaId,
                                cidId: aplicacao.cidId,
                                comunicanteHanseniase: aplicacao.comunicanteHanseniase,
                                gestante: aplicacao.gestante,
                                puerpera: aplicacao.puerpera,
                                imunizacaoAdvertida: aplicacao.imunizacaoAdvertida,
                                viajante: aplicacao.viajante,
                                ultimoFrasco: aplicacao.ultimoFrasco,
                                observacao: aplicacao.observacao,
                                aprazamentoId: aplicacao.aprazamentoId,
                                viaAdministracaoId: aplicacao.viaAdministracaoId,
                                localAplicacaoId: aplicacao.localAplicacaoId,
                            }
                        }),
                    atualizacoes: this.model.registroVacinacao.registros
                        .filter(registro => registro.registroTipo === 'atualizacao')
                        .map(atualizacao => {
                            return {
                                aplicadorId: atualizacao.aplicadorId,
                                dataRegistro: atualizacao.dataRegistro,
                                doseId: atualizacao.doseId,
                                entradaId: atualizacao.lote?.id,
                                equipeId: atualizacao.equipeId,
                                grupoAtendimentoId: atualizacao.grupoAtendimentoId,
                                id: atualizacao.id,
                                localAtendimentoId: atualizacao.localAtendimentoId,
                                lote: atualizacao.lote,
                                observacao: atualizacao.observacao,
                                ocupacaoId: atualizacao.ocupacaoId,
                                salaVacinacaoId: atualizacao.salaVacinacaoId,
                                turnoId: atualizacao.turnoId,
                                vacinaId: atualizacao.vacinaId,
                                cidId: atualizacao.cidId,
                            }
                        }),
                }
            }

            if (this.additionals.isDemandaEspontanea) {
                request.desfecho.ocupacaoId = this.model.preAtendimento.desfecho.ocupacaoId
                request.desfecho.especialidadeId = this.model.preAtendimento.desfecho.especialidadeId
                request.desfecho.usuarioId = this.model.preAtendimento.desfecho.usuarioId
            }

            this.repositories.atendimentoEnfermagem.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    if (this.model.preAtendimento.desfecho.finalizado === true) {
                        this.openModalDeclaracaoComparecimento(response.data.atendimentoId, {
                            preAtendimentoId: response.data.id
                        })
                    } else {
                        this.openModalImpressao(response.data.atendimentoId)
                    }
                })
                .catch(error => {

                    let erroPersonalizado = '';

                    if (error.response.data.message === "Trying to get property 'cria_ficha_ab' of non-object") {
                        erroPersonalizado = 'É necessário cadastrar uma sala de vacinação para a unidade';
                        this.showValidationNotification(erroPersonalizado);
                    }else{
                        this.handleError(error);
                    }
                })
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const hasProcedimentoComInstrumentoRegistroRaas = this.model.preAtendimento.procedimentos.some(procedimento => !!procedimento.hasInstrumentoRegistroRaas)

                    if (!!this.additionals.faturaProcedimentoRaas && hasProcedimentoComInstrumentoRegistroRaas) {
                        this.checkCamposInvalidosParaFaturarProcedimentoRaas()
                    } else {
                        this.store()
                    }
                })
        },
        openModalDeclaracaoComparecimento(atendimentoId, params) {
            this.showConfirmation(
                `Deseja gerar a declaração de comparecimento?`,
                async () => {this.$nextTick().then(() => this.$refs.ModalDeclaracaoComparecimento.open(atendimentoId, params))},
                async () => {this.$nextTick().then(() => this.openModalImpressao(atendimentoId))}
            )
        },
        openModalImpressao(atendimentoId) {
            this.$refs.ModalImpressao.open('pre-atendimento', atendimentoId)
        },
        canceledModalDeclaracaoComparecimento(atendimentoId) {
            this.openModalImpressao(atendimentoId)
        },
        savedModalDeclaracaoComparecimento(atendimentoId) {
            this.openModalImpressao(atendimentoId)
        },
        closedModalImpressao() {
            this.showSaveNotification()
            this.$emit('saved')
        },
        handlePesoChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!this.hasProcedimentoPeso()) {
                    this.insertProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)
                }
            } else {
                const antropometria = this.model.preAtendimento.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!antropometria.peso) {
                    this.deleteProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)
                }
            }
        },
        handleAlturaChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!this.hasProcedimentoAltura()) {
                    this.insertProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)
                }
            } else {
                const antropometria = this.model.preAtendimento.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!antropometria.altura) {
                    this.deleteProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)
                }
            }
        },
        handlePerimetroCefalicoChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.preAtendimento.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handleCircunferenciaAbdominalChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.preAtendimento.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handlePerimetroPanturrilhaChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.preAtendimento.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handlePressaoArterialChange(value) {
            if (value) {
                if (!this.hasProcedimentoPressaoArterial()) {
                    this.insertProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            }
        },
        handleTemperaturaChange(value) {
            if (value) {
                if (!this.hasProcedimentoTemperatura()) {
                    this.insertProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            }
        },
        handleGlicemiaCapilarChange(value) {
            if (value) {
                if (!this.hasProcedimentoGlicemiaCapilar()) {
                    this.insertProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
            }
        },
        handleTesteRapidoChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        handleAdministracaoMedicamentoChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        handleOutroProcedimentoChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        handleColetaMaterialChange(value) {
            if (value.checked) {
                if (!this.hasProcedimento(value.codigo)) {
                    this.insertProcedimento(value.codigo)
                }
            } else {
                this.deleteProcedimento(value.codigo)
            }
        },
        hasProcedimentoAntropometria() {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AVALIACAO_ANTROPOMETRICA).length > 0
        },
        hasProcedimentoPeso() {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.MEDICAO_DE_PESO).length > 0
        },
        hasProcedimentoAltura() {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.MEDICAO_DE_ALTURA).length > 0
        },
        hasProcedimentoPressaoArterial() {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL).length > 0
        },
        hasProcedimentoTemperatura() {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AFERICAO_DE_TEMPERATURA).length > 0
        },
        hasProcedimentoGlicemiaCapilar() {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.GLICEMIA_CAPILAR).length > 0
        },
        hasProcedimento(codigo) {
            return this.model.preAtendimento.procedimentos.filter(procedimento => procedimento.codigo === codigo).length > 0
        },
        insertProcedimento(codigo) {
            this.setLoading()

            this.repositories.procedimento.index({codigo})
                .then(response => {
                    const procedimento = response.data[0]

                    this.model.preAtendimento.procedimentos.push({
                        id: procedimento.id,
                        codigo: procedimento.codigo,
                        nome: procedimento.nome,
                        hasInstrumentoRegistroRaas: !!procedimento.hasInstrumentoRegistroRaas,
                        automatico: true,
                        quantidade: 1,
                        localCurativo: null,
                        materialId: null,
                        materialDescricaoCompleta: null,
                        materialQuantidade: null,
                        materialEscolheuEntradaItemManualmente: null,
                        materialEntradaItens: null,
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        deleteProcedimento(codigo) {
            const index = this.model.preAtendimento.procedimentos.findIndex(procedimento => procedimento.codigo === codigo)

            if (index !== -1) {
                this.model.preAtendimento.procedimentos.splice(index, 1)
            }
        },
        printCarteiraVacinacao() {
            this.setLoading()

            this.repositories.impressaoImunizacao.carteiraVacinacao(this.form.paciente.id)
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        checkCamposInvalidosParaFaturarProcedimentoRaas() {
            const camposInvalidos = []

            if (!this.form.unidade.cnes) {
                camposInvalidos.push('CNES da unidade de atendimento')
            }

            if (!this.form.paciente.nomeMae) {
                camposInvalidos.push('Nome da mãe do paciente')
            }

            if (!this.form.paciente.cep) {
                camposInvalidos.push('CEP do logradouro do paciente')
            }

            if (!this.form.paciente.ibge) {
                camposInvalidos.push('IBGE do logradouro do paciente')
            }

            if (!this.form.paciente.dataNascimento) {
                camposInvalidos.push('Data de nascimento do paciente')
            }

            if (!this.form.paciente.sexoId) {
                camposInvalidos.push('Sexo do paciente')
            }

            if (!this.form.paciente.racaCorId) {
                camposInvalidos.push('Raça/Cor do paciente')
            }

            if (!this.form.paciente.telefoneNumero) {
                camposInvalidos.push('Número do telefone do paciente')
            }

            if (camposInvalidos.length > 0) {
                let message = 'Campos inválidos para faturamento RAAS:<ul>'

                camposInvalidos.forEach(campoInvalido => {
                    message = message + `<li>${campoInvalido}</li>`
                })

                message = message + '</ul>Deseja continuar?'

                this.showWarningConfirmation('Atenção', message, async () => this.store())
            } else {
                this.store()
            }
        },
        isIdadeGestacional() {
            return (this.form.paciente.sexoId === this.enums.sexo.FEMININO) &&
                    (this.model.registroVacinacao.cidadaoIdadeAnos >= 9 && this.model.registroVacinacao.cidadaoIdadeAnos <= 60);
        },
    },
    mixins: [error, file, permissao, repository, stringCase, unmask],
    mounted() {
        this.load()
    },
    props: {
        filaId: {type: Number, required: true},
    },
}
</script>